import { useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
import { QuestionProApi } from '@BUP/services/Axios';

const questionProApiKey = process.env.REACT_APP_QUESTION_PRO_API_KEY;
const questionProUserId = process.env.REACT_APP_QUESTION_PRO_USER_ID;

export const useQuestionProApi = (survey, rolName) => {
  const folderID = survey?.folder_id_questionpro;
  const userId = questionProUserId;
  const apiKey = questionProApiKey;

  const [listState, setListState] = useState({
    isLoadingSurveyQP: false,
    folder: [],
    surveyQP: {},
    errorSurveyQP: null,
    requestQuestionPro: null,
  });

  const getResource = useCallback(async () => {
    setListState((prevState) => ({
      ...prevState,
      isLoadingSurveyQP: true,
    }));
    try {
      const requestQuestionPro = await QuestionProApi.get(
        `/users/${userId}/folders/${folderID}/surveys?apiKey=${apiKey}`
      );
      const data = requestQuestionPro?.data;
      const folder = data?.response ? data?.response : [];
      // Filtro de folders para encontrar la url correspondiente al rol de usuario
      const filterFolder = folder?.filter((folder) =>
        folder?.name?.toLowerCase().includes(rolName?.toLowerCase())
      );
      const [surveyFiltered] = filterFolder;
      setListState((prevState) => ({
        ...prevState,
        folder,
        surveyQP: surveyFiltered,
        requestQuestionPro,
      }));
    } catch (error) {
      console.log('useQuestionProApi error', error);
      setListState((prevState) => ({
        ...prevState,
        errorSurveyQP: error,
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoadingSurveyQP: false,
      }));
    }
  }, [setListState, folderID]);

  useEffect(() => {
    if (folderID) {
      getResource();
    }
  }, [getResource, folderID]);

  return {
    isLoadingSurveyQP: listState.isLoadingSurveyQP,
    folder: listState.folder,
    surveyQP: listState.surveyQP,
    errorSurveyQP: listState.errorSurveyQP,
    requestQuestionPro: listState.requestQuestionPro,
  };
};
